export default {
    template: document.querySelector('[data-quiz-dialogue-template]') ?
        document.querySelector('[data-quiz-dialogue-template]').innerHTML:
        null,
    props: {
        question: {
            type: Object,
            required: false
        },
        copy: {
            type: Object,
            required: false
        },
        extra: {
            type: Object,
            required: false
        },
        completed: {
            type: Boolean,
            required: true
        },
        youtubeapiloaded: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            audio: null,
            audioEnded: false,
            showAudioDialogue: false,

            videoPlayer: null,
            showVideoDialogue: false,

            showQuestionDialogue: false,
            wrongAnswer: null,

            showCongratulationsDialogue: false,

            questionLoaded: false,
            questionLetter: null
        };
    },
    methods: {
        openQuestionModal() {
            this.showAudioDialogue = false;
            this.showVideoDialogue = true;
            if (this.audio) {
                this.audio.pause();
            }

            this.$refs.congratulationsDialogue.style.visibility = 'hidden';
            this.$refs.congratulationsDialogue.style.animationDuration = '0.56s';
            this.$refs.congratulationsDialogue.style.animationDelay = '0.56s';

            this.playVideo();
        },

        playVideo() {
            if (this.youtubeapiloaded) {
                this.videoPlayer.playVideo();
            }
        },

        createYouTubeEmbed() {
            // create a youtube player
            this.videoPlayer = new YT.Player(this.$refs.videoPlayer, {
                height: '360',
                width: '640',
                videoId: this.question.videoId,
                playerVars: {
                    // controls: 0,
                },
                events: {
                    'onStateChange': this.onPlayerStateChange
                }
            });
        },

        onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.ENDED) {
                this.closeVideoPlayer();
            }
        },

        closeVideoPlayer() {
            this.showQuestionDialogue = true;
            this.showVideoDialogue = false;
            this.videoPlayer.destroy();
        },

        answerClicked(e, answer) {
            if (answer.isCorrect) {
                this.completeQuestion();
                return;
            }

            this.wrongAnswer = this.copy.wrongAnswer;
        },

        completeQuestion() {
            this.wrongAnswer = null;
            this.showCongratulationsDialogue = true;
            this.showQuestionDialogue = false;

            setTimeout(() => {
                this.$refs.congratulationsDialogue.style.visibility = 'visible';
            }, 600);
        },

        /**
         * Create an audio object and play it
         */
        handleAudio() {
            this.audio = new Audio(this.question.audioUrl);
            this.audio.play();
            this.audio.addEventListener('ended', () => {
                this.audio = null;
                this.audioEnded = true;
            });
        },

        closeModal() {
            this.$refs.congratulationsDialogue.style.animationDelay = '0s';

            if (this.completed) {
                this.$refs.congratulationsDialogue.addEventListener('animationend', () => {
                    this.$emit('close-modal');
                });
            } else {
                this.$refs.congratulationsDialogue.addEventListener('animationend', () => {
                    this.$emit('question-completed');
                });
            }

            this.showCongratulationsDialogue = false;
        },

        /**
         * Give consent for youtube video's
         */
        giveYoutubeConsent() {
            this.$emit('youtube-consent-given');
        }
    },
    mounted() {
        this.questionLetter = this.extra[this.question.id].letter;

        if (this.completed) {
            this.$refs.audioDialogue.style.visibility = 'hidden';
            this.$refs.questionDialogue.style.visibility = 'hidden';
            this.$refs.congratulationsDialogue.style.animationDelay = '0s';
            this.$refs.congratulationsDialogue.style.animationDuration = '0.56s';

            this.showAudioDialogue = false;
            this.showCongratulationsDialogue = true;
            return;
        }

        this.showAudioDialogue = true;

        // preload youtube video!
        if (this.youtubeapiloaded) {
            this.createYouTubeEmbed();
        } else {
            window.onYouTubePlayerAPIReady = () => {
                this.createYouTubeEmbed();
            };
        }
        // make audio play
        this.handleAudio();

        this.questionLoaded = true;
    }
}